export default {
  HiddenField: {
    updated() {
      this.dispatchUpdate();
    },

    dispatchUpdate() {
      const input = this.el.querySelectorAll('[data-input]')[0]; // Note: it's enough to update the first field for arrays as well

      if (input) {
        // Ensure its called after all internal events
        setTimeout(() => {
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }, 20);
      }
    },
  },
};
